import "../../_namespaces.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseListSelectOneChoice = class ResponseListSelectOneChoice extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.handleResponseSelected = this.handleResponseSelected.bind(this);
  }

  initialize() {
    // Radio buttons don't fire a change event when deselected so we need to trigger change so their models update
    return this.listenTo(this.collection, "change:selected", this.handleResponseSelected);
  }

  render() {
    this.$el.html(
      this.collection.map((response) => {
        response = new AssessmentViewer.Views.ResponseSelectOneChoice({ model: response });
        return jQuery("<li>").append(response.render().el);
      }),
    );

    return this;
  }

  // EVENT HANDLERS

  handleResponseSelected(updatedResponse, state) {
    if (!state) {
      return;
    }
    return this.collection.forEach((response) => {
      if (response !== updatedResponse) {
        return response.set("selected", false);
      }
    });
  }
};
AssessmentViewer.Views.ResponseListSelectOneChoice.prototype.tagName = "ul";
AssessmentViewer.Views.ResponseListSelectOneChoice.prototype.className = "response-list";
